import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import _ from "lodash";
import { baseURL } from "../services/axiosConfig";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import useDeviceType from "../Utiles/FindDevice";
import { refreshTokenV2 } from "../services/api";
import { useNavigate } from "react-router";

export default function BannerSection() {
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const deviceType = useDeviceType();
  const path = window.location.href.split("/")[3];
  const navigate = useNavigate();
  const dispatch = useDispatch()
  useEffect(() => {
    (async () => {
      try {
        let response;
        if (path === "rounds" || path === "rounds#") {
          response = await axios.get(
            `${baseURL}/accounts/adv-banner/list/?status=true&placement=rounds_page`
          );
          setBanners(response.data);
        } else {
          response = await axios.get(
            `${baseURL}/accounts/adv-banner/list/?status=true&placement=home`
          );
          setBanners(response.data);
        }
        const filteredBanners = response.data.filter(
          (banner) =>
            banner?.placement == "home" || banner?.placement == "rounds_page"
        );
        setBanners(filteredBanners);
      } catch (error) {
        if (error?.response?.status === 401) {
          refreshTokenV2(dispatch);
        }
        console.error("Error fetching banner data:", error);
      }
    })();
  }, []);


  useEffect(() => {
    if (banners.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 15000);

    return () => clearInterval(interval);
  }, [banners.length]);

  const goToSlide = useCallback((index) => {
    setCurrentIndex(index);
  }, []);

  const goToPrevious = useCallback(() => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? banners.length - 1 : prevIndex - 1
    );
  }, [banners.length]);

  const goToNext = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  }, [banners.length]);

  if (!banners.length) return null;

  const sliderWidth = banners.length * 100;

  // Helper function to get arrow size based on device type
  const getArrowSize = () => {
    if (deviceType === "mobile") return 12;
    if (deviceType === "tablet") return 16;
    return 20;
  };

  // Helper function to get arrow button size based on device type
  const getArrowButtonSize = () => {
    if (deviceType === "mobile") return "28px";
    if (deviceType === "tablet") return "32px";
    return "40px";
  };

  const handleBannerNavigation = (link) => {
    if (!link) return;

    if (!isNaN(link)) {
      navigate(`/rounds`, { state: { roundId: link } });
      window.scrollTo(0, 0);
    } else if (typeof link === "string" && (link.startsWith("http") || link.startsWith("https"))) {
      window.open(link, "_blank", "noopener,noreferrer");
    } else {
      navigate(`/${link}`);
      window.scrollTo(0, 0);
    }
  };


  return (
    <div
      className="md:py-[32px] px-0"
      style={{
        position: "relative",
      }}
    >
      <section
        className="mx-auto overflow-hidden carousel-section"
        style={{
          width: "92%",
          background: "none",
          border: "none",
          boxSizing: "border-box",
          alignItems: "stretch",
          position: "relative",
          borderRadius: "0",
        }}
      >
        <div
          className="carousel-track sm:h-[400px] md:h-[280px] lg:h-[280px] 2xl:h-[460px]"
          style={{
            display: "flex",
            transition: "transform 0.7s cubic-bezier(0.4,0,0.2,1)",
            transform: `translateX(-${(currentIndex * 100) / banners.length}%)`,
            width: `${sliderWidth}%`,
            borderRadius: "0",
          }}
        >
          {banners?.map((banner, idx) => (
            <div
              className="carousel-slide cursor-pointer"
              key={idx}
              style={{
                flex: `0 0 ${100 / banners?.length}%`,
                display: "flex",
                minWidth: 0,
                position: "relative",
                backgroundImage: `url('${banner?.image}')`,
                backgroundSize: "contain",
                backgroundPosition: "center",
                aspectRatio: "21/8",
              }}
              onClick={() => handleBannerNavigation(banner?.link)}
            >
              <div
                className="overlay"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 1,
                }}
              />

              <div
                className={`carousel-content banner-${banner?.text_placement_side || 'left'}`}
                style={{
                  position: "relative",
                  zIndex: 2,
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  padding: "clamp(16px, 4vw, 52px)",
                  boxSizing: "border-box",
                }}
              >
                <div className="content-wrapper">
                  <h2
                    className="heading"
                    style={{
                      color: `${banner?.title_color || '#fff'}`,
                      fontFamily: "Archivo, sans-serif",
                      fontWeight: 600,
                      margin: 0,
                      marginBottom: "clamp(8px, 2vw, 18px)",
                      lineHeight: 1.2,
                    }}
                  >
                    {banner?.name}
                  </h2>
                  <p
                    className="description"
                    style={{
                      color: "#C6D6F7",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 500,
                      margin: 0,
                      marginBottom: "clamp(16px, 3vw, 38px)",
                      lineHeight: 1.3,
                    }}
                  >
                    {banner?.description}
                  </p>
                  {banner?.button_text && (
                    <button
                      className="slider-button"
                      style={{
                        background: _.isEmpty(banner?.btn_background_color)
                          ? "linear-gradient(90deg, #7cffb2 0%, #5ab0ff 100%)"
                          : banner?.btn_background_color,
                        color: _.isEmpty(banner?.button_color)
                          ? "#142842"
                          : banner?.button_color,
                        fontFamily: "Inter, sans-serif",
                        fontWeight: 600,
                        borderRadius: 3,
                        border: "none",
                        boxShadow: "0px 4px 16px #00000014",
                        cursor: banner?.link ? "pointer" : "default",
                        transition: "opacity 0.2s",
                        width: "fit-content",
                        alignSelf: banner?.text_placement_side === "center"
                          ? "center"
                          : banner?.text_placement_side === "right"
                            ? "flex-end"
                            : "flex-start",
                      }}
                      onClick={() => handleBannerNavigation(banner?.link)}
                      disabled={!banner?.link}
                    >
                      {banner?.button_text}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {banners.length > 1 && (
          <>
            {currentIndex > 0 && (
              <button
                onClick={goToPrevious}
                style={{
                  position: "absolute",
                  left: deviceType === "mobile" ? "5px" : "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255, 255, 255, 0.4)",
                  border: "none",
                  borderRadius: "50%",
                  width: getArrowButtonSize(),
                  height: getArrowButtonSize(),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 2,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.4)";
                }}
              >
                <IoIosArrowBack size={getArrowSize()} color="#333" />
              </button>
            )}

            {currentIndex < banners.length - 1 && (
              <button
                onClick={goToNext}
                style={{
                  position: "absolute",
                  right: deviceType === "mobile" ? "5px" : "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255, 255, 255, 0.4)",
                  border: "none",
                  borderRadius: "50%",
                  width: getArrowButtonSize(),
                  height: getArrowButtonSize(),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 2,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 1)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(255, 255, 255, 0.4)";
                }}
              >
                <IoIosArrowForward size={getArrowSize()} color="#333" />
              </button>
            )}

            <div
              style={{
                position: "absolute",
                bottom: deviceType === "mobile" ? "45px" : "20px",
                left: "50%",
                transform: "translateX(-50%)",
                display: "flex",
                gap: "8px",
                zIndex: 2,
              }}
            >
              {banners?.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`
                    w-[4px] h-[4px] md:w-[10px] md:h-[10px] rounded-full border-none
                    cursor-pointer p-0
                    ${index === currentIndex ? "bg-white" : "bg-white/50"}
                  `}
                />
              ))}
            </div>
          </>
        )}
      </section>

      <style>
        {`
          .carousel-track { 
            will-change: transform; 
          }

          .carousel-section {
            width: 100%;
          }

          .carousel-slide {
            aspect-ratio: 16 / 6;
            background-size: contain !important;
            background-repeat: no-repeat !important;
            background-position: center !important;
            overflow: hidden;
          }

          .carousel-content {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
          }

          .content-wrapper {
            width: 100%;
            max-width: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;
          }

          .banner-left .content-wrapper {
            align-items: flex-start;
            text-align: left;
            max-width: min(90%, 600px);
          }

          .banner-center .content-wrapper {
            align-items: center;
            text-align: center;
            max-width: min(90%, 600px);
            margin: 0 auto;
          }

          .banner-right .content-wrapper {
            align-items: flex-end;
            text-align: right;
            max-width: min(90%, 600px);
            margin-left: auto;
          }

          .heading {
            font-size: clamp(18px, 4.5vw, 32px) !important;
            word-wrap: break-word;
            overflow-wrap: break-word;
            hyphens: auto;
          }

          .description {
            font-size: clamp(14px, 3vw, 20px) !important;
            word-wrap: break-word;
            overflow-wrap: break-word;
            hyphens: auto;
          }

          .slider-button {
            font-size: clamp(12px, 2.5vw, 16px) !important;
            padding: clamp(8px, 2vw, 12px) clamp(16px, 4vw, 30px) !important;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
          }

          /* Updated arrow button styles for responsive design */
          button[style*="position: absolute"][style*="left:"],
          button[style*="position: absolute"][style*="right:"] {
            width: clamp(24px, 4vw, 40px) !important;
            height: clamp(24px, 4vw, 40px) !important;
          }

          .carousel-section > div:last-child button {
            width: clamp(6px, 1.5vw, 10px);
            height: clamp(6px, 1.5vw, 10px);
          }

          @media (max-width: 768px) {
            .carousel-slide {
              aspect-ratio: 16 / 12;
            }
            
            .carousel-content {
              padding: clamp(20px, 24vw, 32px) !important;
            }

            /* Tablet content styles - same as mobile */
            .heading {
              font-size: clamp(16px, 4vw, 24px) !important;
            }
            
            .description {
              font-size: clamp(12px, 2.8vw, 16px) !important;
            }
            
            .slider-button {
              font-size: clamp(10px, 2.2vw, 14px) !important;
              padding: clamp(6px, 1.5vw, 10px) clamp(12px, 3vw, 20px) !important;
            }

            /* Tablet arrow sizes */
            button[style*="position: absolute"][style*="left:"],
            button[style*="position: absolute"][style*="right:"] {
              width: 32px !important;
              height: 32px !important;
            }
          }

          @media (max-width: 600px) {
            .carousel-slide {
              aspect-ratio: 16 / 8;
            }
            
            .heading {
              font-size: clamp(16px, 4vw, 24px) !important;
            }
            
            .description {
              font-size: clamp(12px, 2.8vw, 16px) !important;
            }
            
            .slider-button {
              font-size: clamp(10px, 2.2vw, 14px) !important;
              padding: clamp(6px, 1.5vw, 10px) clamp(12px, 3vw, 20px) !important;
            }
          }

          @media (max-width: 500px) {
            .carousel-slide {
              aspect-ratio: 16 / 10;
            }
            
            .carousel-content {
              padding: clamp(10px, 2.5vw, 24px) !important;
            }
            
            .heading {
              font-size: clamp(14px, 3.5vw, 20px) !important;
              margin-bottom: clamp(6px, 1.5vw, 12px) !important;
            }
            
            .description {
              font-size: clamp(10px, 2.5vw, 14px) !important;
              margin-bottom: clamp(12px, 2.5vw, 20px) !important;
            }
            
            .slider-button {
              font-size: clamp(9px, 2vw, 12px) !important;
              padding: clamp(5px, 1.2vw, 8px) clamp(10px, 2.5vw, 16px) !important;
            }

            /* Mobile arrow sizes */
            button[style*="position: absolute"][style*="left:"],
            button[style*="position: absolute"][style*="right:"] {
              width: 28px !important;
              height: 28px !important;
            }
          }

          @media (max-width: 400px) {
            .carousel-slide {
              aspect-ratio: 16 / 12;
            }
            
            .carousel-section {
              width: 95% !important;
            }
            
            .carousel-content {
              padding: clamp(8px, 2vw, 20px) !important;
            }
            
            .heading {
              font-size: clamp(12px, 3vw, 18px) !important;
              margin-bottom: clamp(4px, 1vw, 8px) !important;
            }
            
            .description {
              font-size: clamp(9px, 2.2vw, 12px) !important;
              margin-bottom: clamp(8px, 2vw, 16px) !important;
            }
            
            .slider-button {
              font-size: clamp(8px, 1.8vw, 10px) !important;
              padding: clamp(4px, 1vw, 6px) clamp(8px, 2vw, 12px) !important;
            }

            /* Smaller mobile arrow sizes */
            button[style*="position: absolute"][style*="left:"],
            button[style*="position: absolute"][style*="right:"] {
              width: 26px !important;
              height: 26px !important;
            }
          }

          @media (max-width: 460px) {
            .carousel-slide {
              background-size: 100% 90px !important;        
              aspect-ratio: 24 / 8 !important;
            }
                        
            .heading {
              font-size: clamp(10px, 2.8vw, 16px) !important;
            }
            
            .description {
              font-size: clamp(8px, 2vw, 10px) !important;
            }
            
            .slider-button {
              font-size: clamp(7px, 1.6vw, 9px) !important;
              padding: clamp(3px, 0.8vw, 5px) clamp(6px, 1.5vw, 10px) !important;
            }

            /* Extra small mobile arrow sizes */
            button[style*="position: absolute"][style*="left:"],
            button[style*="position: absolute"][style*="right:"] {
              width: 24px !important;
              height: 24px !important;
            }
          }
        `}
      </style>
    </div>
  );
}
